/**
 * How the drawer knows WHERE a container navigation came from.
 *
 * The auto-open collision cap exists for one situation: the user picked a
 * canvas/chat in the LEFT RAIL, and the drawer expanding underneath would
 * push that very row below the fold. Switching through the TAB BAR carries
 * no rail selection to protect, so those navigations should open the drawer
 * at its normal size (the stored share, or the default).
 *
 * The tab bar marks its container navigations here right before calling
 * `navigate`; the drawer's auto-open effect consumes the mark on the route
 * change it caused. Consuming clears it, and a freshness window keeps a
 * mark that never got consumed (e.g. a tap that landed on the already-open
 * container) from leaking into a later rail-driven navigation.
 */

const FRESH_MS = 2000;

let markedAt = 0;

/** Call right before a tab-bar-driven `navigate` to a canvas/chat route. */
export function markTabBarContainerNavigation(): void {
  markedAt = Date.now();
}

/**
 * True when the container route change now being handled was tab-bar-driven.
 * Clears the mark either way.
 */
export function consumeTabBarContainerNavigation(): boolean {
  const fresh = markedAt !== 0 && Date.now() - markedAt < FRESH_MS;
  markedAt = 0;
  return fresh;
}
